module.exports = __webpack_public_path__ + "static/media/of-the-day-dark.974f68a8.png";